import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './NestedTable.html?raw';
import docu from './NestedTableDocumentation.html?raw';
import "../GenericDialog/GenericDialog";
import _StatefulBase from '../_StatefulBase/_StatefulBase';


//import DataItems = require("DataItems");


class NestedTable extends compose(_LabelInputBase) {
    templateString: any = template;

    parentTableContainer: HTMLElement;
    containerNoEntries: HTMLDivElement;

    groupingEnabled: boolean = false;
    groupingParameter: string;
    sortDirection: "ASC" | "DESC";

    rows_per_entity: number = 1;

    stickyHeader: boolean = false;
    headerBgColor: string;
    headerTxtColor: string;

    data: Array<object> = [];

    Formatter: Function = function (value: any, header: string, node: HTMLElement, entity: object) { if (typeof value == "string") node.innerHTML = value };

    customRowClasses: Array<string> = [];

    textOvefrlow: boolean = true;

    tableRegistry: Array<tableRegistryObject> = []; // data-table_id == parentTRIndex_depthIndex_layoutName_entityListName

    tableLayoutStyleType: string = "fixed";

    config: NestedTableConfig;

    isLazyLoading: boolean = true;

    sortData(data: Array<object>): void {

        let compareFuction: any;
        let this_smogler: any = this;
        let propertyName: string = this.groupingParameter

        // wenn es einen Gruppierungsparam gibt
        if (propertyName) {
            let attrValue: string;

            //eine beliebige Value finden, um den Type zu kennen
            for (let i = 0; i < this.data.length; i++) {
                attrValue = this.PitHelper.getEntityAttributeValue(this.data[i], propertyName, more.PitHelperStructureFormatType.json);
                if (attrValue) { break; }

            }

            if (!isNaN(Number(attrValue))) {
                // wenn es eine Zahl ist
                if (this.sortDirection == "DESC") {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                } else {

                    compareFuction = function (a, b) {
                        let result: any = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json) -
                            this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json);
                        return result;
                    }

                }

            } else {

                //wenn es ein String ist

                if (this.sortDirection == "DESC") {
                    compareFuction = function (a, b) {

                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return 1;
                        }
                        if (fa > fb) {
                            return -1;
                        }
                        return 0;
                    }
                } else {
                    compareFuction = function (a, b) {
                        //console.log(a, b)
                        let fa = this_smogler.PitHelper.getEntityAttributeValue(a, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        let fb = this_smogler.PitHelper.getEntityAttributeValue(b, propertyName, more.PitHelperStructureFormatType.json).toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    }
                }
            }

            data.sort(compareFuction);

        } else {
            alert("no grouping parameter!")
        }
    }

    // wraper für die drawTable, falls es meherere Tables (lists) auf derselben Ebene gibt, eg drawTable mit denselben parametern für jedes config
    drawTablesForLists(containerNode: HTMLElement, config: NestedTableConfig | Array<NestedTableConfig>, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string): void {

        this.removeChildTablesFromRegistry(containerNode) // total destruction of everything that is inside
        containerNode.innerHTML = null;

        if (Array.isArray(config)) {

            for (let tableConfig of <NestedTableConfig[]>config) {

                let containerDiv = this.UiModder.domConstruct.create("div", {
                    innerHTML: "if you see this, the drawTable function is broken",
                    className: "nestedTableContainerDiv w3-section",
                    style: {
                        textAlign: "center"
                    }
                }, containerNode);

                this.drawTable(containerDiv, tableConfig, tableDepthIndex, data, parentTableRowIndexesPfad);
            }

        } else {

            // das Top Level config ist ein dokument
            let containerDiv = this.UiModder.domConstruct.create("div", {
                innerHTML: "if you see this, the drawTable function is broken",
                className: "nestedTableContainerDiv w3-section",
                style: {
                    textAlign: "center"
                }
            }, containerNode);

            this.drawTable(containerDiv, <NestedTableConfig>config, tableDepthIndex, data, parentTableRowIndexesPfad);
        }
    }
    // rendert die Header und das TableLabel, basierend auf "collapsible", ja nach "collapsed" ruft die Methode welche dann die data Rows baut (oder nicht)
    drawTable(containerNode: HTMLElement, config: NestedTableConfig, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string): void {

        let tableRegistryIndex: number = null;
        let indentHeaderForButton: boolean = config.nestedLists && config.nestedLists.length > 0;
        let tableLayouts: Array<NestedTableLayout> = config.layouts && config.layouts.length ? config.layouts : [];

        // vorerst nehmen wir einfach das erste
        let selectedLayout: NestedTableLayout = tableLayouts.length ? tableLayouts[0] : null;

        if (data == null) data = this.data;
        if (config.connectionList) {
            data = data[config.connectionList]; // data kann this.data sein oder die rowEntity
        }

        if (containerNode == null) containerNode = this.parentTableContainer;
        this.UiModder.domConstruct.empty(containerNode);

        let collapsed: boolean = false; // default - auf false lassen 
        if (config && config.collapsible == true) collapsed = config.collapsed; 

        // Table label (dies ist sozusagen der TableManager der NextSibling-Tabelle) ---------------------------- START

        // ein Label für jedes Layout implemntieren, wenn es nur einen Layout gibt, und das table ist nicht collapsible, brauchen wir das nicht
        if (tableLayouts.length > 1 || config.collapsible === true) {

            //container für die Labels machen, darüber kontrollieren wir alle children:
            let tableLablesContainer = this.UiModder.domConstruct.create("div", {
                className: "tableLablesContainer"
            }, containerNode, "first");

            for (let k = 0; k < config.layouts.length; k++) {

                let tabLabelIcon: HTMLElement;

                let layout: NestedTableLayout = config.layouts[k];

                let labelDiv = this.UiModder.domConstruct.create("div", {
                    className: "NestedTable_tabLabel w3-left w3-light-gray",
                    style: {
                        cursor: (config.collapsible) ? "pointer" : "default",
                         //NestedTable.css
                    },
                }, tableLablesContainer);

                if (k == 0) {
                    labelDiv.classList.add("NestedTable_tabLabel_selected");
                    labelDiv.classList.remove("NestedTable_tabLabel_not_selected");
                } else {
                    labelDiv.classList.add("NestedTable_tabLabel_not_selected");
                    labelDiv.classList.remove("NestedTable_tabLabel_selected");
                }

                let arrowDiv = this.UiModder.domConstruct.create("div", {
                    className: "NestedTable_tabLabel_arrow w3-light-gray",
                    style: {
                        //NestedTable.css
                    }
                }, labelDiv);

                this.UiModder.domConstruct.create("span", {
                    innerHTML: `${config.label} (${layout.label})`
                }, labelDiv);

                on(labelDiv, "mouseover", function (evt) {
                    labelDiv.classList.remove("w3-light-gray");
                    labelDiv.classList.add("w3-gray");
                    arrowDiv.classList.remove("w3-light-gray");
                    arrowDiv.classList.add("w3-gray");
                });

                on(labelDiv, "mouseout", function (evt) {
                    labelDiv.classList.add("w3-light-gray");
                    labelDiv.classList.remove("w3-gray");
                    arrowDiv.classList.add("w3-light-gray");
                    arrowDiv.classList.remove("w3-gray");
                });

                if (config.collapsible) tabLabelIcon = this.UiModder.domConstruct.create("i", {
                    className: collapsed ? "fas fa-caret-down" : "fas fa-caret-up",
                    style: {
                        margin: "5px"
                    }
                }, labelDiv, "first");

                on(labelDiv, "click", lang.hitch(this, function (evt) {

                    selectedLayout = layout;
                    this._emptyTable(table);
                    this._createHeadSectionforTable(table, selectedLayout, indentHeaderForButton);
                    labelDiv.classList.add("NestedTable_tabLabel_selected");
                    labelDiv.classList.remove("NestedTable_tabLabel_not_selected");

                    if (config.collapsible === true) {

                        if (!tabLabelIcon) tabLabelIcon = this.UiModder.domConstruct.create("i", {
                            className: collapsed ? "fas fa-caret-down" : "fas fa-caret-up",
                            style: {
                                margin: "5px"
                            }
                        }, labelDiv, "first");

                        if (tabLabelIcon.classList.contains("fa-caret-down")) {
                            //state: geschlossen -> öffnen

                            for (let b = 0; b < tableLablesContainer.children.length; b++) {
                                if (tableLablesContainer.children[b] != labelDiv) {
                                    (<HTMLElement>tableLablesContainer.children[b]).classList.remove("NestedTable_tabLabel_selected");
                                    (<HTMLElement>tableLablesContainer.children[b]).classList.add("NestedTable_tabLabel_not_selected");
                                }

                                for (let i = 0; i < tableLablesContainer.children[b].getElementsByTagName("i").length; i++) {
                                    let icon = tableLablesContainer.children[b].getElementsByTagName("i")[i];
                                    if (icon != tabLabelIcon) {
                                        icon.classList.remove("fa-caret-up");
                                        icon.classList.add("fa-caret-down");
                                    }
                                }
                            }

                            tabLabelIcon.classList.remove("fa-caret-down");
                            tabLabelIcon.classList.add("fa-caret-up");
                            collapsed = false;

                            //(table: HTMLTableElement, selectedLayout: NestedTableLayout, data: Array < object >, config: NestedTableConfig, tableRegistryIndex: number)

                            this._createDataRowsForTable(table, selectedLayout, data, config, tableRegistryIndex);

                        } else {
                            // state open -> schießen
                            tabLabelIcon.classList.remove("fa-caret-up");
                            tabLabelIcon.classList.add("fa-caret-down");
                            collapsed = true;

                            this._destroyTagNameElementsOfTable(table, "tr");
                        }

                    } else {

                        // keine collaps-ding - einfach daten anzegen

                        //state: geschlossen -> öffnen

                        for (let b = 0; b < tableLablesContainer.children.length; b++) {
                            if (tableLablesContainer.children[b] != labelDiv) {
                                (<HTMLElement>tableLablesContainer.children[b]).classList.remove("NestedTable_tabLabel_selected");
                                (<HTMLElement>tableLablesContainer.children[b]).classList.add("NestedTable_tabLabel_not_selected");
                            }
                        }

                        //(table: HTMLTableElement, selectedLayout: NestedTableLayout, data: Array < object >, config: NestedTableConfig, tableRegistryIndex: number)

                        this._createDataRowsForTable(table, selectedLayout, data, config, tableRegistryIndex);

                    }
                    
                }));

            }

        }

        // Table label (dies ist sozusagen der TableManager der NextSibling-Tabelle) ---------------------------- END

        // instantiate the empty table and set all table attributes 
        var table: HTMLTableElement = <HTMLTableElement>this.UiModder.domConstruct.create("table", {
            className: "w3-table w3-bordered"
        }, containerNode);

        if (parentTableRowIndexesPfad !== null && config["connectionList"] !== null) {
            this.UiModder.domAttr.set(table, "data-table_id", `${parentTableRowIndexesPfad}-${tableDepthIndex}-${config["name"]}-${config["connectionList"]}`);
        } else {
            this.UiModder.domAttr.set(table, "data-table_id", `${this.id}_parentTable`);
        }

        if (tableDepthIndex != null) {
            this.UiModder.domAttr.set(table, "data-depth_index", tableDepthIndex);
            this.UiModder.domClass.add(table, "nestedTable_childTable");
        } else {
            console.log("provide depth index oh the clicked table +1 as a parameter for child tables to have the correct depth index!")
        }

        if (this.textOvefrlow == true) {
            this.UiModder.domStyle.set(table, "table-layout", this.tableLayoutStyleType);
            if (this.stickyHeader === false) {
                // sticky header funktioniert nicht mit overflow hidden
                this.UiModder.domStyle.set(table, "overflow", "hidden");
            }
        }

        if (tableDepthIndex === 0 && !parentTableRowIndexesPfad) {
            this.setDataCyAttribute(table, "");
        } else {
            table.setAttribute("data-cy", "nestedTable:" + (table.getAttribute("data-table_id") ?? ""));
        }
        table.setAttribute("data-e2e-role", "table");

        //gibt den index des eingefügten/mpdifizierten registryObj zurück /args:/ table: HTMLTableElement, data: object[], config: NestedTableLists, parentTableRowIndexesPfad: string, tableDepthIndex: number
        tableRegistryIndex = this.addTableToRegistry(table, data, config, parentTableRowIndexesPfad, tableDepthIndex);

        // Create head section with the right Layout
        this._createHeadSectionforTable(table, selectedLayout, indentHeaderForButton);
        
        // render td row if not collapsed
        if (collapsed === false) this._createDataRowsForTable(table, selectedLayout, data, config, tableRegistryIndex);

    } 

    _createHeadSectionforTable(table: HTMLTableElement, layout: NestedTableLayout, indentHeaderForButton: boolean = false): void {

        this._emptyTable(table);

        // TH kreieren ---start
        let tableHead: HTMLElement = this.UiModder.domConstruct.create("thead", { className: "nestedTable_thead w3-light-gray" }, table);

        for (let x = 0; x < layout.rows.length; x++) {
            let colspans: Array<number> = layout.rows[x].colspans;
            let headers: Array<string> = layout.rows[x].headings;

            let headerRow: HTMLElement = this.UiModder.domConstruct.create("tr", null, tableHead);

            for (let z = 0; z < colspans.length; z++) {

                if ( indentHeaderForButton && z == 0) {
                    this.UiModder.domConstruct.create("td", { "innerHTML": "", "width": "48px" }, headerRow);
                }

                let th = this.UiModder.domConstruct.create("th", {
                    "innerHTML": headers[z],
                    "colspan": colspans[z]
                }, headerRow);
                if (this.stickyHeader === true) {
                    this.UiModder.domStyle.set(th, "position", "sticky");
                    this.UiModder.domStyle.set(th, "top", "0px");
                    this.UiModder.domStyle.set(th, "z-index", "99");
                }
                if (this.headerBgColor) {
                    this.UiModder.domStyle.set(th, "background-color", this.headerBgColor);
                }
                if (this.headerTxtColor) {
                    this.UiModder.domStyle.set(th, "color", this.headerTxtColor);
                }
            }
        }
        // TH kreieren-----end
    }

    _createDataRowsForTable(table: HTMLTableElement, selectedLayout: NestedTableLayout, data: Array<object>, config: NestedTableConfig, tableRegistryIndex: number): void {

        let i: number, x: number = null;
        let colspans: Array<number> = [];

        let parentTableRowIndexesPfad = this.UiModder.domAttr.get(table, "data-table_id").split("-")[0];

        if (!parentTableRowIndexesPfad || parentTableRowIndexesPfad.indexOf(this.id) == -1) {
            parentTableRowIndexesPfad = null;
        }

        if (tableRegistryIndex == null) {
            for (let reg = 0; reg < this.tableRegistry.length; reg++) {
                if (this.tableRegistry[reg].table == table) tableRegistryIndex = reg;
            }
        }

        // Data rows ----------------------start

        if (data.length == 0) {
            this.UiModder.domClass.remove(this.containerNoEntries, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.containerNoEntries, "w3-hide");
        }

        // durch das data array loopen 
        for (x = 0; x < data.length; x++) {

            let tableRowEntity = data[x];

            let tableRowIndex: number = x;

            if (this.tableRegistry[tableRegistryIndex].rowData.length == 0) {
                this.tableRegistry[tableRegistryIndex].rowData.push({ entity: tableRowEntity, rowIndex: tableRowIndex });
            } else {
                let foundIt: boolean = false;
                for (let registryObj of this.tableRegistry[tableRegistryIndex].rowData) {
                    if (registryObj.rowIndex == tableRowIndex) {
                        registryObj.entity = tableRowEntity;
                        foundIt = true;
                    }
                }
                if (foundIt == false) {
                    this.tableRegistry[tableRegistryIndex].rowData.push({ entity: tableRowEntity, rowIndex: tableRowIndex });
                }
            }

            // render group headers for groupings, falls enabled -----------start

            // colspn für die groupingsPberschrift ermitteln
            let groupingColspan: number = colspans.length;

            // GroupingsÜberschriften rendern
            if (this.groupingEnabled) {
                if (x == 0) {
                    let groupHeader: HTMLElement = this.UiModder.domConstruct.create("tr", { "class": "table_groupHeader" }, table);
                    this.UiModder.domConstruct.create("td", {
                        "colspan": groupingColspan,
                        "innerHTML": this.PitHelper.getEntityAttributeValue(tableRowEntity, this.groupingParameter, more.PitHelperStructureFormatType.json)
                    }, groupHeader);

                } else if (this.PitHelper.getEntityAttributeValue(data[x], this.groupingParameter, more.PitHelperStructureFormatType.json) != this.PitHelper.getEntityAttributeValue(data[x - 1], this.groupingParameter, more.PitHelperStructureFormatType.json)) {

                    let groupHeader: HTMLElement = this.UiModder.domConstruct.create("tr", { "class": "table_groupHeader" }, table);

                    this.UiModder.domConstruct.create("td", {
                        "colspan": groupingColspan,
                        "innerHTML": this.PitHelper.getEntityAttributeValue(tableRowEntity, this.groupingParameter, more.PitHelperStructureFormatType.json)
                    }, groupHeader);
                }
            }
            // render group headers for groupings, falls enabled -----------end

            //render rowdata --------------------------------------------start
            for (i = 0; i < selectedLayout.rows.length; i++) {
                // die rows-Per-Entity (abschnitte) sichtbar separieren
                let top_row_border_style: string = null;

                if (selectedLayout.rows.length > 1 && i == 0) {
                    top_row_border_style = "border-top: 5px solid gray !important;"
                }

                let currentRowIndexPfad: string = parentTableRowIndexesPfad !== null ? parentTableRowIndexesPfad + "_" + x : String(x);

                let row = this.UiModder.domConstruct.create("tr", {
                    "data-tr_indexes_pfad": currentRowIndexPfad,
                    "style": top_row_border_style
                }, table); //data objct

                // stelle fest ob wir den Button, einen leeren td für indentation, oder gar nichts einbauen sollen, und das der Row-bau-Funktion als arg übergeben
                let isRowExpandable: boolean = null;

                /////// now that we have lazy loading, so our only parameter for expanding is the "nestedLists" config
                if (config.nestedLists && config.nestedLists.length) {
                    //wenn es einen Layout und Data für die nächsste Tabelle gibt
                    
                    if (i < selectedLayout.rows.length - 1) {
                        // multirow-entity, der button gehört an den letzten row,
                        // einen indent-td bauen
                        isRowExpandable = false;
                    } else {
                        //letzter row - einen Button bauen
                        isRowExpandable = true;
                    }

                } 

                this._renderTableDataForRow(<HTMLTableRowElement>row, tableRowEntity, selectedLayout.rows[i], isRowExpandable);
            }
            //render rowdata --------------------------------------------end
        }
    }

    private _renderTableDataForRow(row: HTMLTableRowElement, tableRowEntity: object, entityRowsLayout: NestedTableRowLayout, isRowExpandable: boolean = null): void {

        let colspans: Array<number> = entityRowsLayout.colspans;
        let propertynames: Array<string> = entityRowsLayout.attributes;
        let headers: Array<string> = entityRowsLayout.headings;
        let colNames: Array<string> = entityRowsLayout.colnamesInternal;
        let bgColors: Array<string> = entityRowsLayout.bgColors;
        let txtColors: Array<string> = entityRowsLayout.txtColors;
        
        let currentRowIndexPfad: string = this.UiModder.domAttr.get(row, "data-tr_indexes_pfad");

        for (let j = 0; j < colspans.length; j++) {

            let bgColor: string = this._getColorForConfigAttributeValue(bgColors[j], tableRowEntity, true);
            let txtColor: string = this._getColorForConfigAttributeValue(txtColors[j], tableRowEntity, false);

            if (txtColor == "" && this._isDarkColorHex(bgColor)) {
                txtColor = "#ffffff";
            } else if (txtColor == "" && !this._isDarkColorHex(bgColor)) {
                txtColor = "#000000";
            }

            if (isRowExpandable !== null && j == 0) { //Achtung hier strenge types, null !== false / null == false
                if (isRowExpandable === false) {
                    //indent td einbaeun
                    this.UiModder.domConstruct.create("td", { "innerHTML": "", "width": "48px" }, row);
                } else {
                   // button einbauen
                    let chevronDownButton = this.UiModder.domConstruct.create("button", {
                        "className": "mds-button-base mds-hover-dark",
                        "style": {
                        },
                        "value": "closed",
                        "onclick": lang.hitch(this, function (evt) {
                            evt.stopPropagation();
                            this._onClickExpandTableButton(evt, tableRowEntity, currentRowIndexPfad)
                        })
                    });
                    this.setDataCyAttribute(chevronDownButton, "expand:" + currentRowIndexPfad);
                    this.UiModder.domConstruct.create("i", {
                        className: "fas fa-caret-down  w3-large"
                    }, chevronDownButton);
                    this.UiModder.domConstruct.place(chevronDownButton, row);
                }
            }

            let outputValue: any;
            let td_colspan: number = 1;

            td_colspan = <number>colspans[j];

            if (propertynames[j]) {
                outputValue = this.PitHelper.getEntityAttributeValue(tableRowEntity, propertynames[j], more.PitHelperStructureFormatType.json);
            } else {
                outputValue = "";
            }

            // wenn textoverflow is_enabled, müssen wir einen div in das td einsetzen, damit textOverflow funzt
            if (this.textOvefrlow === true) {

                let td_node = this.UiModder.domConstruct.create("td", {
                    "data-label": headers[j],
                    "colspan": td_colspan,
                    "style": {
                        overflow: "hidden",
                        color: txtColor,
                        backgroundColor: bgColor
                    }
                }, row);

                let td_div = this.UiModder.domConstruct.create("div", {
                    "style": "white-space: no-wrap; overflow:hidden; text-overflow: ellipsis; ",
                    "innerHTML": null, // the formatter function below provides innerHTML
                    "onclick": function (e) {

                        if (e.target.offsetWidth < e.target.scrollWidth) {
                            e.target.setAttribute("class", " table_dropdown");

                            let dropdown = document.createElement("div");
                            dropdown.setAttribute("class", "table_dropdown_content");

                            let content: Text = document.createTextNode(outputValue);

                            // einen dropdown element einbauen, damit der ganze Txtonclock angezeigt wird
                            dropdown.appendChild(content);

                            e.target.parentElement.appendChild(dropdown);

                            window.onclick = function (event) {
                                if (event.target.matches('.table_dropdown') || event.target.matches('.table_dropdown_content')) {
                                } else {
                                    let dropdowns: HTMLCollectionOf<Element> = document.getElementsByClassName("table_dropdown_content");

                                    for (let y = 0; y < dropdowns.length; y++) {
                                        dropdowns[y].remove();
                                    }
                                }
                            }

                        }
                    }
                }, td_node);

                // die Formatter Funktion ist ein filter, der die Datenausgabe bestimmt.
                let desc: string = colNames ? colNames[j] : headers[j];
                this.Formatter(outputValue, desc, td_div, tableRowEntity);

            } else {

                let outputValue: any;

                if (propertynames[j]) {
                    outputValue = this.PitHelper.getEntityAttributeValue(tableRowEntity, propertynames[j], more.PitHelperStructureFormatType.json);
                } else {
                    outputValue = "";
                }

                let td_node = this.UiModder.domConstruct.create("td", {
                    "innerHTML": null,
                    "colspan": td_colspan,
                    style: {
                        color: txtColor,
                        backgroundColor: bgColor
                    }
                }, row);  // the formatter function below provides innerHTML
                // die Formatter Funktion ist ein filter, der die Datenausgabe bestimmt. 
                let desc: string = colNames ? colNames[j] : headers[j];
                this.Formatter(outputValue, desc, td_node, tableRowEntity);

            }

        }
    }

    _getColorForConfigAttributeValue(value: string, entity: object, BgColor: boolean): string {

        let hexColorRegex: RegExp = /^#[0-9a-f]{6}$|^#[0-9a-f]{8}$|^#[0-9A-F]{6}$|^#[0-9A-F]{8}$/i;

        if (value) {
            // is it a hex string value?
            if (hexColorRegex.test(value)) {
                return value;
            } else {
                // it is a path? may be a treasure?
                let treasureBox: string | object = this.PitHelper.getEntityAttributeValue(entity, value, more.PitHelperStructureFormatType.json);

                if (treasureBox) {
                    if (typeof treasureBox == "string" && hexColorRegex.test(treasureBox)) {
                        // it is a valid hex color representation
                        return treasureBox;

                    } else if (treasureBox["BackColor"] && treasureBox["TextColor"]) {
                        // es ist ein coloration object
                        if (BgColor == true && treasureBox["BackColor"].IsNull == false) {
                            return treasureBox["BackColor"].Hex;
                        } else if (treasureBox["TextColor"].IsNull == false){
                            return treasureBox["TextColor"].Hex;
                        }
                    }
                }
            }
        } 
        return "";
    }

    _isDarkColorHex(hexValue): boolean {

        if (hexValue) {

            let color: string = hexValue.substring(1);      // strip #
            if (color.length > 6) color = color.slice(0, 7); // hex opacity has length of 2
            let rgb: number = parseInt(color, 16);   // convert rrggbb to decimal
            let r: number = (rgb >> 16) & 0xff;  // extract red
            let g: number = (rgb >> 8) & 0xff;  // extract green
            let b: number = (rgb >> 0) & 0xff;  // extract blue

            var luma: number = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            if (luma < 125) { // luma value range is 0..255, where 0 is the darkest and 255 is the lightest
                return true;
            }
        }

        return false;
    }

    _emptyTable(table: HTMLTableElement): void {

        this._destroyTagNameElementsOfTable(table, "tr");
        this._destroyTagNameElementsOfTable(table, "th");
        this._destroyTagNameElementsOfTable(table, "thead");
        table.innerHTML == null;

    }

    _destroyTagNameElementsOfTable(table: HTMLTableElement, tagName: string): void {

        let elementsToDelete: Array<HTMLElement> = [];
        for (let i = 0; i < table.children.length; i++) {
            if (table.children[i].tagName.toLowerCase() == tagName.toLowerCase()) {
                elementsToDelete.push(<HTMLElement>table.children[i]);
            }
        }

        for (let tableCildElement of elementsToDelete) {
            if (tagName == "tr") this.removeChildTablesFromRegistry(tableCildElement);
            this.UiModder.domConstruct.destroy(tableCildElement);
        }
    }

    addTableToRegistry(table: HTMLTableElement, data: object[], config: NestedTableConfig, parentTableRowIndexesPfad: string, tableDepthIndex: number): number {

        let newRegistryObj: tableRegistryObject = {
            table: table,
            entityList: data,
            config: config,
            parentTableRowIndexesPfad: parentTableRowIndexesPfad,
            depthIndex: tableDepthIndex,
            widgets: [],
            rowData: []
        };

        let index: number = -1;

        if (this.tableRegistry.length) {
            for (let i = 0; i < this.tableRegistry.length; i++) {
                if (this.tableRegistry[i].table == table) {
                    index = i;
                }
            }
        }

        if (index != -1) {
            this.tableRegistry[index] = newRegistryObj;
        } else {
            this.tableRegistry.push(newRegistryObj);
            index = this.tableRegistry.length - 1;
        }

        return index;
    }

    removeChildTablesFromRegistry(containerNode: HTMLElement): void {

        let tableIds: string[] = [];

        let children = containerNode.getElementsByTagName("table");

        // lokalisieren
        for (let i = 0; i < children.length; i++) {
            let index: number = -1;
            for (let j = 0; j < this.tableRegistry.length; j++) {
                if (this.tableRegistry[j].table == children[i]) {
                    this.clearWidgetRegistryForTable(this.tableRegistry[j].table);
                    index = j;
                }
            }
            if (index != -1) this.tableRegistry.splice(index, 1);
        }
    }

    _onClickExpandTableButton(evt, tableRowEntity: {}, clickedRowIndexesPfad: string): void {

        let clickedButton: HTMLButtonElement;
        let clickedRow: HTMLTableRowElement;
        


        if (evt.target.tagName == "I") {
            clickedButton = <HTMLButtonElement>evt.target.parentElement;
        } else if (evt.target.tagName == "BUTTON") {
            clickedButton = <HTMLButtonElement>evt.target;
        }

        clickedRow = <HTMLTableRowElement>clickedButton.parentElement;

        if (clickedButton.value == "open") {

            this.removeChildTablesFromRegistry(<HTMLElement>clickedRow.nextSibling);

            this._closeExpandChildTable(false, clickedRow );

            clickedButton.value = "closed";

            this.UiModder.domClass.remove(clickedButton.firstChild, "fa-caret-up");
            this.UiModder.domClass.add(clickedButton.firstChild, "fa-caret-down");

        } else {

            if (clickedButton.value == "closed") {
                

                clickedButton.value = "open";

                this.UiModder.domClass.remove(clickedButton.firstChild, "fa-caret-down");
                this.UiModder.domClass.add(clickedButton.firstChild, "fa-caret-up");

                if (this.isLazyLoading === true) {
                    // load data first
                    this.loadChildTableData(evt, tableRowEntity, clickedRowIndexesPfad);
                } else {
                    this._closeExpandChildTable(true, clickedRow, tableRowEntity, clickedRowIndexesPfad);
                }
            }
        }
    }

    _closeExpandChildTable(bOpen: boolean, clickedRow: HTMLTableRowElement, tableRowEntity?, clickedRowIndexesPfad?: string): void {


        if (bOpen) {

            let clickedTable: HTMLTableElement = <HTMLTableElement>clickedRow.parentElement;
            let clickedTableDepthIndex: number = Number(clickedTable.dataset["depth_index"]);
            let tableConfig: NestedTableConfig = null;
            let clickdRowColspans: number = 0;

            let rowTds = clickedRow.getElementsByTagName("TD");

            for (let i = 0; i < rowTds.length; i++) {
                let colpans = Number(this.UiModder.domAttr.get(rowTds[i], "colspan"));
                if (!isNaN(colpans)) clickdRowColspans += colpans;
            }

            for (let i = 0; i < this.tableRegistry.length; i++) {
                if (this.tableRegistry[i].table == clickedTable) {
                    tableConfig = this.tableRegistry[i].config;
                }
            }

            if (tableConfig == null) {
                alert("ERROR: refere to console");
                console.error("No config (List) for table ", clickedTable, " found!");
                return;
            }

            let newRow = this.UiModder.domConstruct.create("tr", {

            });

            // indent in der Größe des buttons schaffen
            let indentTd = this.UiModder.domConstruct.create("td", {
                colspan: 1
            }, newRow)

            let newTd = this.UiModder.domConstruct.create("td", {
                colspan: clickdRowColspans
            }, newRow);

            this.UiModder.domConstruct.place(newRow, clickedRow, "after");

            // /drawTablesForLists args:/ containerNode: HTMLElement, config: NestedTableLists | Array<NestedTableLists>, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string
            this.drawTablesForLists(newTd, tableConfig.nestedLists, clickedTableDepthIndex + 1, tableRowEntity, clickedRowIndexesPfad);

        } else {
            this.UiModder.domConstruct.destroy(clickedRow.nextSibling);
        }
    }

    loadChildTableData(evt, tableRowEntity, clickedRowIndexesPfad: string): void {

        this.StandbyStart();

        //// die Idee ist: die entityLists im Backend an die Parent entity anzuhängen und als dokument zu überreichen,
        //// später vorne ersetzen wir die richtige entity einfach in der tableData et voila

        let clickedButton: HTMLButtonElement;
        let clickedRow: HTMLTableRowElement;
        let tableConfig: NestedTableConfig;
        let clickedTable: HTMLTableElement;


        // die richtige config finden

        if (evt.target.tagName == "I") {
            clickedButton = <HTMLButtonElement>evt.target.parentElement;
        } else if (evt.target.tagName == "BUTTON") {
            clickedButton = <HTMLButtonElement>evt.target;
        }
        clickedRow = <HTMLTableRowElement>clickedButton.parentElement
        clickedTable = <HTMLTableElement>clickedRow.parentElement;

        for (let i = 0; i < this.tableRegistry.length; i++) {
            if (this.tableRegistry[i].table == clickedTable) {
                tableConfig = this.tableRegistry[i].config;
            }
        }
        if (tableConfig == null) {
            alert("ERROR: refere to console");
            console.error("No config (List) for table ", clickedTable, " found!");
            return;
        }

        // hier holen wir die entitylist - und attributnamen uas dem table config

        let data: { parentEntityId: string, parentEntityClassname: string, parentEntityAttributes: Array<string>,  entityLists: Array<{entityListName: string, attributes: Array<string>}>} =
            { parentEntityId: null, parentEntityClassname: null, parentEntityAttributes: [], entityLists: [] };

        data.parentEntityId = tableRowEntity["ID"];
        data.parentEntityClassname = tableRowEntity["Classname"];

        // jede entitylist soll entsprechend alle attribute kriegen die sie in jeglichem layout gebrauchen kann
        for (let i = 0; i < tableConfig.nestedLists.length; i++) {
            let nestedList = tableConfig.nestedLists[i];
            let childTableRequestParams: { entityListName: string, attributes: Array<string> } = { entityListName: nestedList.connectionList, attributes: [] }

            // die attributnamen der zuckünftigen TAbelle mitgeben, damit die richtigen properties vorhanden sind
            for (let layout of nestedList.layouts) {
                for (let row of layout.rows) {
                    for (let attribute of row.attributes) {
                        if (childTableRequestParams.attributes.indexOf(attribute) == -1) {
                            childTableRequestParams.attributes.push(attribute);
                        }
                    }

                    // coloration attribute können Farbwerte oder entityattribute sein
                    for (let bgColorAttribute of row.bgColors) {
                        if (bgColorAttribute != "" && bgColorAttribute != null && bgColorAttribute.indexOf("#") == -1 && data.parentEntityAttributes.indexOf(bgColorAttribute) == -1) {
                            childTableRequestParams.attributes.push(bgColorAttribute);
                        }
                    }
                    for (let txtColorAttribute of row.txtColors) {
                        if (txtColorAttribute != "" && txtColorAttribute != null && txtColorAttribute.indexOf("#") == -1 && data.parentEntityAttributes.indexOf(txtColorAttribute) == -1) {
                            childTableRequestParams.attributes.push(txtColorAttribute);
                        }
                    }
                }
            }
            data.entityLists.push(childTableRequestParams);
        }   

        // die Parent entity attributes mitgeben
        for (let layout of tableConfig.layouts) {
            for (let row of layout.rows) {
                for (let attributeName of row.attributes) {
                    if (data.parentEntityAttributes.indexOf(attributeName) == -1) {
                        data.parentEntityAttributes.push(attributeName);
                    }
                }

                // coloration attribute können Farbwerte oder entityattribute sein
                for (let bgColorAttribute of row.bgColors) {
                    if (bgColorAttribute != "" && bgColorAttribute != null && bgColorAttribute.indexOf("#") == -1 && data.parentEntityAttributes.indexOf(bgColorAttribute) == -1 ) {
                        data.parentEntityAttributes.push(bgColorAttribute);
                    }
                }
                for (let txtColorAttribute of row.txtColors) {
                    if (txtColorAttribute != "" && txtColorAttribute != null && txtColorAttribute.indexOf("#") == -1 && data.parentEntityAttributes.indexOf(txtColorAttribute) == -1) {
                        data.parentEntityAttributes.push(txtColorAttribute);
                    }
                }

            }
        }


        this.RequestManager.post(
            window.appRoot + "ProjectFinder/NestedTable_LoadChildTableData",
            {
            jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadChildTableDataResponse, { clickedRow: clickedRow, tableRowEntity: tableRowEntity, clickedRowIndexesPfad: clickedRowIndexesPfad}),
            lang.hitch(this, this._onLoadChildTableDataError)
        )

    }

    _onLoadChildTableDataResponse(clickedTableData: { clickedRow: HTMLTableRowElement, tableRowEntity: any, clickedRowIndexesPfad: string }, response): void {

        this.StandbyStop();
        if (response && response.ID) {
            clickedTableData.tableRowEntity = response;

           // _closeExpandChildTable args | bOpen: boolean, clickedRow: HTMLTableRowElement, tableRowEntity ?, clickedRowIndexesPfad ?: string
            this._closeExpandChildTable(true, clickedTableData.clickedRow, clickedTableData.tableRowEntity, clickedTableData.clickedRowIndexesPfad);
        } else {
            console.error(" _onLoadChildTableDataResponse ERROR: ", response);
        }
    }

    _onLoadChildTableDataError(err): void {
        this.StandbyStop();
        console.error(err);
    }

    


    addLineConfig(config: NestedTableConfig): void {

        this.config = config;

        // /drawTablesForLists args:/ containerNode: HTMLElement, config: NestedTableLists | Array<NestedTableLists>, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string
        this.drawTablesForLists(this.parentTableContainer, config, 0, this.data, null);

    }

    //Eine klasse für die rows mit bestimmeten entity properties setzen 
    setRowClass_Based_On_EntityProperty(tables: Array<HTMLTableElement>, entityParameter_key: string, entityParameter_value: any, rowClass: string): void {

        for (let table of tables) {

            let sDatasetValues: string = this.UiModder.domAttr.get(table, "data-table_id");

            let index: number = -1;

            if (this.tableRegistry.length) {
                for (let i = 0; i < this.tableRegistry.length; i++) {
                    if (this.UiModder.domAttr.get(this.tableRegistry[i].table, "data-table_id") == sDatasetValues) {
                        index = i;
                    }
                }
            }

            let tableRegistryObj = index > -1 ? this.tableRegistry[index] : null;

            if (tableRegistryObj) {
                let tableRows: HTMLCollectionOf<Element> = table.getElementsByTagName("tr");

                for (let k = 0; k < tableRegistryObj.rowData.length; k++) {
                    let displayedEntity = tableRegistryObj.rowData[k].entity;
                    let entityValue = this.PitHelper.getEntityAttributeValue(displayedEntity, entityParameter_key, more.PitHelperStructureFormatType.json);

                    if (entityValue == entityParameter_value || (entityParameter_value == "*" && entityValue != null)) {

                        for (let i = 0; i < tableRows.length; i++) {

                            let row = tableRows[i];

                            let tr_indexes_pfad: string = this.UiModder.domAttr.get(row, "data-tr_indexes_pfad");

                            let trIndexes: string[] = tr_indexes_pfad.split("-");
                            let lastIndex: number = Number(trIndexes[trIndexes.length - 1]);

                            if (lastIndex == k) {

                                this.UiModder.domClass.add(row, rowClass);

                                if (!this.customRowClasses) {
                                    this.customRowClasses = [];
                                }

                                if (this.customRowClasses.indexOf(rowClass) == -1) {
                                    this.customRowClasses.push(rowClass);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    removeRowClass_Based_On_EntityProperty(tables: Array<HTMLTableElement>, entityParameter_key: string, entityParameter_value: any, rowClass: string): void {

        for (let table of tables) {

            let sDatasetValues: string = this.UiModder.domAttr.get(table, "data-table_id");

            let index: number = -1;

            if (this.tableRegistry.length) {
                for (let i = 0; i < this.tableRegistry.length; i++) {
                    if (this.UiModder.domAttr.get(this.tableRegistry[i].table, "data-table_id") == sDatasetValues) {
                        index = i;
                    }
                }
            }

            let tableRegistryObj = index > -1 ? this.tableRegistry[index] : null;

            if (tableRegistryObj) {
                let tableRows: HTMLCollectionOf<Element> = table.getElementsByTagName("tr");

                for (let k = 0; k < tableRegistryObj.rowData.length; k++) {
                    let displayedEntity = tableRegistryObj.rowData[k].entity;
                    let entityValue = this.PitHelper.getEntityAttributeValue(displayedEntity, entityParameter_key, more.PitHelperStructureFormatType.json);

                    if (entityValue == entityParameter_value) {

                        for (let i = 0; i < tableRows.length; i++) {

                            let row = tableRows[i];

                            let tr_indexes_pfad: string = this.UiModder.domAttr.get(row, "data-tr_indexes_pfad");

                            let trIndexes: string[] = tr_indexes_pfad.split("-");
                            let lastIndex: number = Number(trIndexes[trIndexes.length - 1]);

                            if (lastIndex == k) {

                                this.UiModder.domClass.remove(row, rowClass);

                                if (this.customRowClasses.indexOf(rowClass) != -1) {
                                    this.customRowClasses.splice(this.customRowClasses.indexOf(rowClass), 1);
                                }
                            }
                        }
                    }
                }
            }
        }

    }

    // einen (string), mehrere (string[]), oder alle (null/undefined) row klassen entfernen (!!!In der ganzen Tabelle!!!), die durch this.setRowClass_Based_On_EntityProperty gesetzt waren
    _removeCustomRowClasses(rowClasses?: string | string[]): void {
        let classesToRemove: string[] = [];
        let tableRows: HTMLCollectionOf<Element> = this.domNode.getElementsByTagName("tr");

        if (rowClasses && typeof rowClasses == "string") {
            classesToRemove.push(<string>rowClasses);
        } else if (rowClasses && rowClasses.length) {
            classesToRemove = <string[]>rowClasses;
        } else {
            // wenn kein valides argument vorhanden - remove all classes
            classesToRemove = this.customRowClasses;
        }

        for (let i = 0; i < tableRows.length; i++) {
            for (let rowClass of classesToRemove) {
                this.UiModder.domClass.remove(tableRows[i], rowClass);
                this.customRowClasses.splice(this.customRowClasses.indexOf(rowClass), 1);
            }
        }
    }

    setTableLayoutStyleType(table: HTMLTableElement, layoutStyle: "fixed" | "auto"): void {

        this.tableLayoutStyleType = layoutStyle;
        this.UiModder.domStyle.set(table, "table-layout", this.tableLayoutStyleType);

    }

    //works only if the table layout is "auto"
    setColumnWidth(table: HTMLTableElement, index: number, width: number): void {

        let theadCollection = table.getElementsByTagName("thead");
        let thForIndex = theadCollection[0].firstChild.childNodes[index];

        this.UiModder.domStyle.set(<HTMLElement>thForIndex, "width", width + "px");
    }

    addWidgetToRegistry(table: HTMLElement, widget: MdsLax<InstanceType<typeof _StatefulBase>>, rowIndex: number, header: string): void {

        let sDatasetValues: string = this.UiModder.domAttr.get(table, "data-table_id");

        let index: number = -1;

        if (this.tableRegistry.length) {
            for (let i = 0; i < this.tableRegistry.length; i++) {
                if (this.UiModder.domAttr.get(this.tableRegistry[i].table, "data-table_id") == sDatasetValues) {
                    // die richtige tabelle
                    index = i;
                }
            }
        }

        if (this.tableRegistry[index].widgets[rowIndex]) {

            if (Array.isArray(this.tableRegistry[index].widgets[rowIndex])) {

                let searchIndex = -1;

                for (let i = 0; i < this.tableRegistry[index].widgets[rowIndex].length; i++) {
                    if (this.tableRegistry[index].widgets[rowIndex][i].header == header) {
                        this.tableRegistry[index].widgets[rowIndex][i] = { widget: widget, header: header };
                        searchIndex = i;
                    }
                }

                if (searchIndex < 0) this.tableRegistry[index].widgets[rowIndex].push({ widget: widget, header: header });

            } else {
                console.error("unexpected format of registry");
            }

        } else {
            this.tableRegistry[index].widgets[rowIndex] = [];
            this.tableRegistry[index].widgets[rowIndex].push({ widget: widget, header: header });
        }

    }

    getRowWidgets(table: HTMLTableElement, rowIndex: number): Array<MdsLax<InstanceType<typeof _StatefulBase>>> {

        let rowWidgets: Array<MdsLax<InstanceType<typeof _StatefulBase>>> = [];

        let sDatasetValues: string = this.UiModder.domAttr.get(table, "data-table_id");

        let index: number = -1;

        if (this.tableRegistry.length) {
            for (let i = 0; i < this.tableRegistry.length; i++) {
                if (this.UiModder.domAttr.get(this.tableRegistry[i].table, "data-table_id") == sDatasetValues) {
                    // die richtige tabelle
                    index = i;
                }
            }
        }

        if (this.tableRegistry[index].widgets[rowIndex]) {

            if (Array.isArray(this.tableRegistry[index].widgets[rowIndex])) {

                if (this.tableRegistry[index].widgets[rowIndex].length) {
                    for (let widgetObj of this.tableRegistry[index].widgets[rowIndex]) {
                        rowWidgets.push(widgetObj.widget);
                    }
                } else {
                    return [];
                }

            } else {
                console.error("unexpected format of widget registry")
            }

        }

        return rowWidgets;
    }

    setHeaderColor(bgColor: string, txtColor: string, table: HTMLTableElement): void {
        this.headerBgColor = bgColor;
        this.headerTxtColor = txtColor;
        //drawTablesForLists args: / containerNode: HTMLElement, config: NestedTableLists | Array<NestedTableLists>, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string
        if (table.innerHTML) this.drawTablesForLists(this.parentTableContainer, this.config, 0, this.data, null);
    }

    setStickyHeader(bool: boolean, table: HTMLTableElement): void {
        this.stickyHeader = bool;
        //drawTablesForLists args: / containerNode: HTMLElement, config: NestedTableLists | Array<NestedTableLists>, tableDepthIndex: number, data?: Array<object>, parentTableRowIndexesPfad?: string
        if (table.innerHTML) this.drawTablesForLists(this.parentTableContainer, this.config, 0, this.data, null);
    }

    clearWidgetRegistryForTable(table: HTMLTableElement): void {

        let index: number = -1;

        if (this.tableRegistry.length) {
            for (let i = 0; i < this.tableRegistry.length; i++) {
                if (this.tableRegistry[i].table == table) {
                    // die richtige tabelle
                    index = i;
                }
            }
        }

        for (let i = 0; i < this.tableRegistry[index].widgets.length; i++) {
            for (let j = 0; j < this.tableRegistry[index].widgets[i].length; j++) {
                this.tableRegistry[index].widgets[i][j].widget.destroy();
            }
        }

        this.tableRegistry[index].widgets = [];
    }


    // Getters und Setters

    setGroupingEnabled(bool: boolean): void {
        this.groupingEnabled = bool;
    }
    setGroupingParameter(param: string): void {
        this.groupingParameter = param;
    }


    setTextOverflow(bool: boolean): void {
        this.textOvefrlow = bool;
    }

    setSortDirection(direction: "ASC" | "DESC"): void {
        this.sortDirection = direction;
    }

    setData(data: Array<object>): void {

        this.data = data;
        this.startup();
    }

    getData(): Array<object> {
        return this.data;
    }

    setFormatter(Formatter: Function): void {
        this.Formatter = Formatter;
    }

    //Dokumentation
    getDocumentationContent(): string {
        return docu;
    }

    // Dojo

    _setFormatterAttr(Formatter: Function): void {
        this.setFormatter(Formatter);
    }
    _setGroupingEnabledAttr(bool: boolean): void {
        this.setGroupingEnabled(bool);
    }
    _setGroupingParameterAttr(param: string): void {
        this.setGroupingParameter(param);
    }

    _setTextOverflowAttr(bool): void {
        this.setTextOverflow(bool);
    }

    _setSortDirectionAttr(direction: "ASC" | "DESC"): void {
        this.setSortDirection(direction);
    }

    _setDataAttr(data: Array<object>): void {
        this.setData(data);
    }
    _setIsLazyLoadingAttr(bool: boolean): void {
        this.setIsLazyLoading(bool);
    }
    setIsLazyLoading(bool: boolean): void {
        this.isLazyLoading = bool;
    }


    public setAllDataCyAttributes() {
        const table = this.parentTableContainer?.querySelector<HTMLElement>("table");
        this.setDataCyAttribute(table, "");
        if (table) table.setAttribute("data-e2e-role", "table");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        console.log("I'M A NESTED TABLE")
       
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        if (this.data && this.config) {
            if (this.groupingParameter) {
                this.sortData(this.data);
            }

            this.drawTablesForLists(this.parentTableContainer, this.config, 0, this.data, null);
        }
    }
}

export default mdsWidget(NestedTable);